module.exports = __webpack_public_path__ + "img/promotion_3.01be1eed.png";